var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_c('list-service',{attrs:{"servicesList":_vm.listServices}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }